import { alpha } from '@mui/material/styles';
import { deprecatedMakeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

const useStyles = deprecatedMakeStyles()((theme) => ({
	container: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: theme.spacing(5),
		[theme.breakpoints.down('md')]: {
			padding: theme.spacing(3.25),
		},
	},
	paddingContainer: {
		borderRadius: theme.shape.borderRadius,
		padding: theme.spacing(5),
		backgroundColor: alpha(theme.palette.grey[200], 0.5),
	},
}));

export default useStyles;
